import types from 'constants/CompanyConstants';
import axios from 'axios';
import qs from 'qs';
import {getURL} from '../routes';

export function fetchCompanyListAPI() {
  return axios.get(getURL('/api/company'))
}

export function addCompanyAPI(name, ownerName, contact, address) {
  return axios.post(getURL('/api/company'),
                qs.stringify({
                  'name': name,
                  'ownerName': ownerName, 
                  'contact': contact, 
                  'address': address
              }))
}

export function updateCompanyAPI(id, name, ownerName, contact, address) {
  return axios.put(getURL('/api/company/') + id,
                qs.stringify({
                  'name': name,
                  'ownerName': ownerName, 
                  'contact': contact, 
                  'address': address
                }))
}

export function deleteCompanyAPI(id) {
  return axios.delete(getURL('/api/company/') + id)
}

export function fetchCompanyList() {
  return dispatch => {
    fetchCompanyListAPI()
      .then((response) => {
        let {company} = response.data;
        dispatch(refreshCompanyList(company));
      })
      .catch((error) => {

      })
  }
}

export function tryUpdateCompany(id, name, ownerName, contact, address) {
  return dispatch => {
    updateCompanyAPI(id, name, ownerName, contact, address)
      .then((response) => {
        dispatch(updateCompany(id, name, ownerName, contact, address))
      })
      .catch((error) => {

      })
  }
}

export function tryAddCompany(name, ownerName, contact, address) {
  return dispatch => {
    addCompanyAPI(name)
      .then((response) => {
        let {id} = response.data;
        dispatch(addCompany(id, name, ownerName, contact, address))
      })
      .catch(() => {
        alert("新增公司失敗")
      })
  }
}

export function tryDeleteCompany(id) {
  return dispatch => {
    deleteCompanyAPI(id)
      .then((response) => {
        dispatch(deleteCompany(id))
      })
      .catch((error) => {
        alert("删除失敗!")
      })
  }
}

export function refreshCompanyList(companyList) {
  return {
    type: types.REFRESH_COMPANY_LIST,
    companyList
  }
}

export function updateCompany(id, name, ownerName, contact, address) {
  return {
    type: types.UPDATE_COMPANY_NAME,
    id, name, ownerName, contact, address
  }
}

export function deleteCompany(id) {
  return {
    type: types.DELETE_COMPANY,
    id
  }
}

export function addCompany(id, name, ownerName, contact, address) {
  return {
    type: types.ADD_COMPANY,
    id, name, ownerName, contact, address
  }
}


// WEBPACK FOOTER //
// ./src/actions/CompanyActions.js